module.exports = __webpack_public_path__ + "static/activators-be81b3b3a90aa3408fd6b27ad5066309.gif";